<div class="verify-email-page">
  <header class="page-head">
    <nav class="page-head__crumbs" aria-label="Breadcrumb">
      <span class="breadcrumb__item">Home</span>
      <span class="breadcrumb__separator" aria-hidden="true">/</span>
      <span class="breadcrumb__item breadcrumb__item--current" aria-current="page"
        >Verify Email</span
      >
    </nav>
  </header>

  <mat-card class="verify-card" appearance="outlined">
    <mat-card-content>
      <!-- Verifying state — shown while API call is in flight -->
      @if (verifyState() === 'verifying') {
        <div
          class="verify-card__state verify-card__state--loading"
          data-testid="verify-state-verifying"
          aria-live="polite"
          aria-busy="true"
        >
          <mat-spinner diameter="40" />
          <p>Verifying your email address…</p>
        </div>
      }

      <!-- Token expired -->
      @if (verifyState() === 'token_expired') {
        <div class="verify-card__state" data-testid="verify-state-expired" aria-live="assertive">
          <h1 class="verify-card__heading verify-card__heading--error">Link Expired</h1>
          <p class="verify-card__body">
            This verification link has expired. Links are valid for 24 hours.
          </p>
          @if (resendSent()) {
            <div
              class="status-message status-message--success"
              data-testid="verify-resend-success"
              role="status"
            >
              Check your inbox — a new link may be on its way.
            </div>
          } @else {
            <p class="verify-card__body verify-card__body--muted">
              Enter your email address to receive a new link.
            </p>
            <div class="resend-form">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Email address</mat-label>
                <input
                  matInput
                  data-testid="verify-resend-email"
                  type="email"
                  placeholder="you@company.com"
                  autocomplete="email"
                  [value]="resendEmail()"
                  (input)="resendEmail.set($any($event.target).value)"
                />
              </mat-form-field>

              <div class="or-divider" aria-hidden="true">
                <span class="or-divider__line"></span>
              </div>

              <button
                mat-flat-button
                data-testid="verify-resend-submit"
                (click)="onResend()"
                [disabled]="!resendEmail() || resendSending() || countdown() !== null"
              >
                @if (resendSending()) {
                  <mat-spinner diameter="20" />
                } @else if (countdown() !== null) {
                  Resend available in {{ countdown() }}s
                } @else {
                  Resend verification email
                }
              </button>
            </div>
          }
          <a [routerLink]="['/auth/login']" class="support-link">Back to Login</a>
        </div>
      }

      <!-- Token already used -->
      @if (verifyState() === 'already_used') {
        <div
          class="verify-card__state"
          data-testid="verify-state-already-used"
          aria-live="assertive"
        >
          <h1 class="verify-card__heading">Link Already Used</h1>
          <p class="verify-card__body">
            This link has already been used. Try logging in — your account is verified.
          </p>

          <div class="or-divider" aria-hidden="true">
            <span class="or-divider__line"></span>
          </div>

          <button mat-flat-button class="full-width" [routerLink]="['/auth/login']">
            Go to Login
          </button>
        </div>
      }

      <!-- Invalid token -->
      @if (verifyState() === 'invalid_token' || verifyState() === 'error') {
        <div class="verify-card__state" data-testid="verify-state-invalid" aria-live="assertive">
          <h1 class="verify-card__heading verify-card__heading--error">Invalid Link</h1>
          <p class="verify-card__body">
            This verification link is invalid. Please request a new one or contact
            <a href="mailto:support@flow.capx.co.za">support&#64;flow.capx.co.za</a>.
          </p>

          <div class="or-divider" aria-hidden="true">
            <span class="or-divider__line"></span>
          </div>

          <button mat-flat-button class="full-width" [routerLink]="['/auth/check-email']">
            Request a new link
          </button>

          <a [routerLink]="['/auth/login']" class="support-link">Back to Login</a>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
